export enum ConvertFailedErrorType {
  SystemError,
}

export enum DrawingType {
  Floorplan,
  Elevation,
}

export enum FileType {
  Pdf = 'PDF',
  Ifc = 'IFC',
  Dxf = 'DXF',
}

export enum FileTag {
  FirstFloor = 'First Floor',
  SecondFloor = 'Second Floor',
  Roof = 'Roof',
}

export interface AWSFile {
  s3_bucketname: string
  s3_filename: string
  s3_folder: string
}

export interface DrawingFile {
  id: string
  name: string
  pages: LoadingPage[]
  tag?: FileTag
  url?: string
  s3Bucket?: string
  s3Filename?: string
  s3Folder?: string
}

export interface Page {
  id: string
  number: number
  image: string
  filename?: string
}

export interface LoadingPage extends Page {
  isLoading?: boolean
}

export interface AnalyzedPage extends LoadingPage {
  name?: string
  drawingType?: DrawingType
  isChecked?: boolean
}

export interface PageDescription {
  file_name: string
  page_number: number
  name: string
}

export interface AnalyzeResult {
  number_of_pages: number
  floorplans: PageDescription[]
  elevations: PageDescription[]
}
